import { AllPlusShopPage } from './AllPlusShopPage';

export const allPlusShopRouter = {
  '/@/creator/plus': AllPlusShopPage, // TODO: path 를 적어주세요.
};
